export default __webpack_public_path__ + "static/media/JUST.c89228d6.png";